<template>
	<div class="promotion-item" v-if="payment">

		<div class="post-box" v-if="more == 1">
			<div class="post-media" :style="{ backgroundImage: 'url('+payment.image+')'}"></div>
			<div class="post-content">
				<div class="row">
					<div class="col-8">
						<h6 class="post-title">
							{{ payment._name }}
						</h6>
						<div class="post-text" v-html="payment.information">
							ss
						</div>
						<div class="post-foot">
							<a class="post-link" href="#"><span>{{ t.details_rules }}</span><i class="os-icon os-icon-arrow-right7"></i></a>
						</div>
					</div>
					<div class="col-4">
						aa
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'paymentItem',
        props: {
            payment: {
                default: null,
            },
            more: {
                default: 1
            }
        },
        data () {
            return {
                msg: '',
                t: this.$root.t,
                session:  this.$root.session
            }
        },
        methods:
            {
                moreText () {
                    return (this.more > 0) ? this.t.promotion.title.click_for_more : this.t.promotion.title.terms_of_contract
                }
            }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/payments/item.vue